/**
****************************************************************************************
Project: Readabl
File: SelectionLayer.js
Description: This component will render selection layer.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import React, { useEffect, useState } from "react";

const SelectionLayer = (props) => {
    const [dimensions, setDimensions] = useState({});
    const [selectedIconPosition, updatePositions] = useState({});
    
    useEffect(() => {
        setDimensions(props?.imageDimensions);
    }, [props.imageDimensions]);

    useEffect(() => {
        if(props.rotateAngle == 270) updatePositions({ left: 880 })
        else if(props.rotateAngle == 180) updatePositions({ left: 880, top: 1160 })
        else if(props.rotateAngle == 90) updatePositions({ top: 1160 })
        else updatePositions({});
    }, [props.rotateAngle])
    return (
        props.selectionEnabled && !props.disabled ? <div
            key={props.key}
            style={{
                width: dimensions?.width,
                height: dimensions?.height,
            }}
            className={`pdf-viewer-selection-layer-page ${props.selectedPages?.includes(props.page) ? "pdf-viewer-selection-layer-page-selected" : ""}`}
            onClick={e => props.handleSelection(props.selectedPages?.includes(props.page) ? "deselect" : "select", props.page)}
        >
            {props.selectedPages?.includes(props.page) ? <CheckCircle
                fontSize="large"
                className="pdf-viewer-selection-checked"
                style={{ position: "relative", ...selectedIconPosition, transform: `rotate(${-props.rotateAngle}deg)` }}
            /> : <RadioButtonUnchecked
                className="pdf-viewer-selection-unchecked"
                fontSize="large"
                style={{ position: "relative", ...selectedIconPosition }}
            />}
        </div> : null
    )
}

export default SelectionLayer;